<template>
  <VueperSlides
    autoplay
    class="no-shadow reviews"
    :visible-slides="3"
    slide-multiple
    :gap="3"
    fixed-height="280px"
    :dragging-distance="50"
    :breakpoints="breakpoints"
    :touchable="false"
    duration="10000"
  >
    <VueperSlide
      v-for="(review, index) in reviewsList"
      :key="'review_'+index"
    >
      <template #content>
        <div class="slide_content">
          <div class="row m-0">
            <div class="review_image text-left">
              <img
                v-if="review.icon"
                class="align-middle"
                alt="Emoji Feliz"
                :src="review.icon"
                height="128"
                width="128"
              >
              <img
                v-else
                class="align-middle"
                alt="Emoji Feliz"
                src="../../assets/img/icons/review-1.png"
                height="128"
                width="128"
              >
            </div>

            <div class="col review_title text-right">
              <span class="subtitle"> {{ review.subtitle }}</span>
              <br>
              <span class="date"> {{ review.date }}</span>
            </div>
          </div>
          <div class="row m-0">
            <div class="review_content">
              <p class="title mb-1">
                {{ review.title }}
              </p>
              <p class="m-0">
                {{ review.content }}
              </p>
            </div>
          </div>
        </div>
      </template>
    </vueperslide>
  </vueperslides>
</template>
<script>
import { VueperSlide, VueperSlides } from 'vueperslides';
import '@/assets/css/custom-vueper-slide.css';
import countries from '@/data/countries';
import { cities } from '@/data/cities';
import { API } from '@/api/api';

const ReviewAPI = API.get('review');

export default {
  name: 'ReviewsCarousel',
  components: {
    VueperSlides,
    VueperSlide,
  },
  data() {
    return {
      reviewsList: [],
      breakpoints:
          {
            600: {
              visibleSlides: 1,
              slideMultiple: 1,
              arrows: true,
              bulletsOutside: true,
              touchable: true,
              fixedHeight: '300px',
            },
            1000: {
              visibleSlides: 2,
              slideMultiple: 2,
              arrows: true,
              bulletsOutside: true,
              touchable: true,
              fixedHeight: '300px',
            },
          },
    };
  },
  async created() {
    try {
      const { data } = await ReviewAPI.getMainReviews(9);
      if (data.length > 0) {
        this.createReviewsList(data);
      } else {
        this.reviewsList = this.$t('lang.home.reviews');
      }
    } catch (error) {
      this.reviewsList = this.$t('lang.home.reviews');
      // not necessary
    }
  },

  methods: {
    createReviewsList(data) {
      let count = 1;
      const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };
      const { lang } = this.$store.state.main;

      data.forEach((review) => {
        let title = '';
        let subtitle = '';
        let date = '';
        let content = '';
        let icon = '';

        const cityIndex = cities.findIndex((city) => city.bd_city_id === review.booking.store.city_id);
        const countryIndex = countries.findIndex((country) => country.id === review.booking.store.country);
        subtitle = `${this.$t(`lang.cities.${cities[cityIndex].id}`)}  ${countries[countryIndex].icon}`;

        title = `${review.booking.user.full_name.split(' ')[0]} ${review.booking.user.full_name.split(' ')[1].substring(0, 1)}.`;

        date = new Date((review.created_at).replace(/-/g, '/')); // Replace function needed to work on Safari
        date = date.toLocaleDateString(lang, dateOptions);

        content = review.comment;

        icon = require(`../../assets/img/icons/review-${count}.png`);
        count++;
        if (count === 10) count = 1;

        this.reviewsList.push({
          title, subtitle, date, content, icon,
        });
      });
    },
  },
};
</script>

<style scoped>
</style>
